import update from "immutability-helper";
import { filter, get, includes, concat } from "lodash";
import { INITIATE_EXPAND_SECTION, EXPAND_ITEM } from "../constants/actionTypes";

const companies = (state = {}, action) => {
  switch (action.type) {
    case INITIATE_EXPAND_SECTION:
      return update(state, {
        [action.section]: {
          $set: {
            expandedCompanies: action.expandedCompanies,
            expandedSites: action.expandedSites,
            expandedZones: action.expandedZones,
          },
        },
      });
    case EXPAND_ITEM:
      let stateSection = get(state, [action.section]);
      if (!stateSection) {
        stateSection = {
          expandedCompanies: [],
          expandedSites: [],
          expandedZones: [],
        };
      }
      if (
        includes(
          get(state, [action.section, action.expandedLevel]),
          action.newId
        )
      ) {
        stateSection = update(stateSection, {
          [action.expandedLevel]: {
            $set: filter(
              get(state, [action.section, action.expandedLevel]),
              (i) => i !== action.newId
            ),
          },
        });
      } else {
        stateSection = update(stateSection, {
          [action.expandedLevel]: {
            $set: concat(get(state, [action.section, action.expandedLevel]), [
              action.newId,
            ]),
          },
        });
      }
      return update(state, {
        [action.section]: { $set: stateSection },
      });
    default:
      return state;
  }
};

export default companies;
